import { Middleware } from '@reduxjs/toolkit';

import {
  continueProcessing,
  processPayment,
  processPaymentFailure,
  processPaymentSuccess,
  registerPayment,
  requestFinteqHub,
  resetPreprocessorData,
  selectPaymentMethod,
  toInitialPaymentInfoState,
} from '@cashier/cashier-data-access';
import { RedirectContainers } from '@cashier/cashier-model';
import {
  AmountConverter,
  ProviderWindowService,
} from '@cashier/cashier-shared';

import { shouldTokenize } from '../helpers';

export const cashierHostedFieldBridgeMiddleware: Middleware =
  (store) => (next) => (action) => {
    const result = next(action);

    if (action.type === requestFinteqHub.toString()) {
      const {
        response,
        status,
        error,
        processingResult: payload,
      } = action.payload;

      if (status) {
        const paymentMethod = selectPaymentMethod(store.getState());

        const isRedirect =
          response?.type === 'redirect' &&
          response?.redirectUrl &&
          RedirectContainers.NEW_TAB === paymentMethod.redirectContainer;

        if (isRedirect) {
          ProviderWindowService.redirect(
            response.redirectUrl,
            paymentMethod.redirectContainer === RedirectContainers.NEW_TAB,
          );

          return;
        }

        if (payload) {
          store.dispatch(processPaymentSuccess(payload));
        }
      } else {
        store.dispatch(
          processPaymentFailure({
            message: error,
            attributeErrorBag: null,
            errorDetails: { description: error },
            transactionId: error?.transactionId,
          }),
        );
      }
    }

    if (action.type === continueProcessing.toString()) {
      const {
        paymentMethods: {
          paymentMethod: {
            vendor,
            id: paymentMethodId,
            referenceId,
            source,
            preprocessor,
          },
          registrationRequired,
        },
        cashierConfiguration: {
          merchantId,
          userId,
          sessionId,
          activeType,
          language,
          hostUrl,
        },
        customerInformation: { bonusCode },
        accounts: { activeAccountOption },
      } = store.getState();

      const preprocessedAttributes: Record<string, any> = {};

      const paymentAttributes = action.payload;
      const callbackParameterBag = {
        userId,
        sessionId,
        merchantId,
        language,
        host: hostUrl,
        paymentMethodId,
      };

      store.dispatch(toInitialPaymentInfoState());

      if (shouldTokenize(preprocessor)) {
        store.dispatch(resetPreprocessorData());
      }

      if (registrationRequired) {
        store.dispatch(
          registerPayment({
            referenceId,
            type: activeType,
            walletId: userId,
            sessionId,
            merchantId,
            registration: {
              accountId: activeAccountOption?.value || null,
              methodId: paymentMethodId,
              attributes: {
                ...paymentAttributes,
                amount: AmountConverter.toNonBreakingString(
                  paymentAttributes.amount as string,
                ),
                bonusCode,
                ...preprocessedAttributes,
              },
            },
          }),
        );
      } else {
        store.dispatch(
          processPayment({
            paymentMethodId,
            vendor,
            merchantId,
            paymentType: activeType,
            userId,
            sessionId,
            accountId: activeAccountOption?.value || null,
            paymentAttributes: {
              ...paymentAttributes,
              amount: AmountConverter.toNonBreakingString(
                paymentAttributes.amount as string,
              ),
              bonusCode,
              ...preprocessedAttributes,
            },
            callbackParameterBag,
            referenceId,
            source,
          }),
        );
      }
    }
    return result;
  };
